import styled from 'styled-components';

// ############################ Imported from Old UI ###########################

export default styled.strong(({ theme }) => ({
  fontWeight: theme.font.weight.bold,
}));
